/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Inventory {

    import fld = MaterialReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialReturnItemsEditor extends _Ext.ItemGridEditor<MaterialReturnItemsRow> {


        protected getColumnsKey() { return "Inventory.MaterialReturnItems"; }
        protected getDialogType() { return MaterialReturnItemsDialog; }
        protected getLocalTextPrefix() { return MaterialReturnItemsRow.localTextPrefix; }
        protected form: MaterialReturnItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public DeptId: number;
        private GenSKU: boolean = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public MasterEntity: any;
        isEditable: boolean;
        public VoucherTypeId: number;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as MaterialReturnDialog).CalculateAmountandTax(this.view.getItems());
                }
            })
        }

        protected getColumns() {

            var columns = super.getColumns(); 
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this); 
            Q.first(columns, x => x.field === fld.Weight).format = wt; 

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }
        private Master: MaterialReturnRow;
        setMasterValues() {
            this.RateListId = (this.parentDialog as MaterialReturnDialog).RateListId;
            this.LaborListId = (this.parentDialog as MaterialReturnDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as MaterialReturnDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as MaterialReturnDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as MaterialReturnDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as MaterialReturnDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as MaterialReturnDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as MaterialReturnDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as MaterialReturnDialog).form.PartyId.value);
            this.VoucherTypeId = (this.parentDialog as MaterialReceiptDialog).form.VoucherTypeId.value;

        } 
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        //}

                    });
                    this.view.refresh();
                    (this.parentDialog as MaterialReturnDialog).CalculateAmountandTax(this.view.getItems());
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }
                        // *** Update Weight, Amount etc on Pieces Change***

            let CurrentStock: Stock.StockItemRow;

            Stock.StockItemService.GetProductDetails({
                ProductId: item.ProductId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                LotNo: item.LotNo,
                TransId: item.TransId,
                TransItemId: item.TransItemId
            },
                response =>
                    CurrentStock = response.Entity,
                { async: false }
            ); 
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {
                if (value > CurrentStock.Weight) {
                    Q.alert('Not Enough Stock');
                    item[field] = CurrentStock.Weight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId != 3) {
                       item.NetWeight = value; 
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }
            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as MaterialReturnDialog).CalculateAmountandTax(this.view.getItems());
            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Inventory.MaterialReceiptSelectGrid;
            buttons = buttons.filter(x => x.cssClass != "add-button");


            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2: Inventory.MaterialReceiptItemsRow[] = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        //alert('Length' + selectedItems.length); 
                        for (var i = 0; i < selectedItems2.length; i++) {
                            var DeptId = 0; 
                            var Item = selectedItems2[i];
                            var VoucherDetails = Q.first(OMS.VoucherMasterRow.getLookup().items, x => x.VoucherTypeId == self.VoucherTypeId);
                            switch (Item.ItemTypeId) {
                                case 101:
                                    DeptId = VoucherDetails.DefaultJewelleryDepartment;
                                    break;
                                case 104:
                                    DeptId = VoucherDetails.DefaultMetalDepartment;
                                    break;
                                case 105:
                                    DeptId = VoucherDetails.DefaultStoneDepartment;
                                    break;
                            } 
                            var item: MaterialReturnItemsRow = {
                                ProductId: Item.ProductId,
                                AttributeId: Item.AttributeId,
                                Attribute: Item.Attribute,
                                Line_No: 0,
                                PartyId: self.PartyId,
                                SKU: "0",
                                DepartmentId: DeptId,
                                ProductCode: Item.ProductCode,
                                ProductName: Item.ProductName,
                                ItemTypeId: Item.ItemTypeId,
                                HasBom: Item.HasBom,
                                CategoryId: Item.CategoryId,
                                ProductTypeId: Item.ProductTypeId,
                                SubCategoryId: Item.SubCategoryId,
                                UnitRate: Item.Rate,
                                Pieces: Item.Pieces >= 0 ? Item.Pieces : 1,
                                Weight: Item.Weight,
                                NetWeight: Item.Weight,
                                NetAmount: 0,
                                GrossAmount: 0,
                                CalcOnId: Item.CalcOnId,
                                CompanyId: Q.Authorization.userDefinition.CompanyId,
                                HSN: Item.HSN,
                                TaxCode: Item.TaxCode,
                                MetalId: Item.MetalId,
                                KaratId: Item.ItemTypeId == 101 ? Item.KaratId : Item.KaratId,
                                MetalColorId: Item.MetalColorId,
                                QualityId: Item.QualityId,
                                SieveId: Item.SieveId,
                                ShapeId: Item.ShapeId,
                                StoneColorId: Item.StoneColorId,
                                StoneSizeId: Item.StoneSizeId,
                                Studded: 0, // marking item as bulk
                                StoneCutId: Item.StoneCutId,
                                StonePolishId: Item.StonePolishId,
                                StoneSymmetryId: Item.StoneSymmetryId,
                                StoneFluorescenceId: Item.StoneFluorescenceId,
                                StoneCuletId: Item.StoneCuletId,
                                StoneGirdleId: Item.StoneGirdleId,
                                StoneTable: Item.StoneTable,
                                StoneDepth: Item.StoneDepth,
                                StoneSizeName: Item.StoneSizeName,
                                ShapeName: Item.ShapeName,
                                GroupSieveName: Item.GroupSieveName,
                                QualityName: Item.QualityName,
                                StoneColoreName: Item.StoneColoreName,
                                SieveName: Item.SieveName,
                                Purity: Item.Purity,
                                LotNo: Item.LotNo,
                                CalcUnitId: Item.CalcUnitId,
                                PureWeight: 0,
                                RefVoucherId: 0,
                                RefTransId: 0,
                                RefTransItemId: 0,
                                IsConfigurable: selectedItems2[i].IsConfigurable,
                                IsCustomerItem: selectedItems2[i].IsCustomerItem,
                                BagNo: Item.BagNo,
                                CertificateNo: Item.CertificateNo,
                                Lab: Item.Lab,
                                StockAllocation: Item.StockAllocation
                            }
                            item[this.getIdProperty()] = "`" + this.nextId++;

                            this.view.addItem(item);
                        }
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });
            ItemGridHelper
            return buttons;
            
        }  
    }
}